import { Skeleton } from '@/common/components/base/skeleton/Skeleton';
import Typography from '@/common/components/base/typography/Typography';
import { Flex } from 'styled-system/jsx';
import WalletWrapperCard from '../walletCards/WalletWrapperCard';

const ROW_LABELS = [
  'شناسه پرونده',
  'تاریخ ایجاد پرونده',
  'تاریخ ارسال به بیمه‌گر',
];

export default function LoadingProjectList() {
  return (
    <Flex flexDirection={'column'} gap={12} width={'100%'}>
      {Array.from({ length: 3 }).map((_, i) => (
        <WalletWrapperCard
          key={i}
          wrapperProps={{
            width: '100%',
            padding: '12px',
            bgColor: 'white',
            border: '1px solid {colors.gray-3}',
          }}
        >
          <Flex flexDirection={'column'} gap={16}>
            <Flex
              height={32}
              justifyContent={'space-between'}
              alignItems={'center'}
            >
              <Skeleton width="110px" height="24px" borderRadius="8px" />
              <Skeleton width="56px" height="24px" borderRadius="8px" />
            </Flex>
            <Flex flexDirection={'column'} gap={8}>
              {ROW_LABELS.map((label) => (
                <Flex
                  key={label}
                  justifyContent={'space-between'}
                  alignItems={'center'}
                >
                  <Typography fontSize={12} color={'black-2'}>
                    {label}
                  </Typography>
                  <Skeleton width="80px" height="24px" borderRadius="8px" />
                </Flex>
              ))}
            </Flex>
          </Flex>
        </WalletWrapperCard>
      ))}
    </Flex>
  );
}
